import React, { useEffect, useState } from "react";
import { apiPut, Get_Api } from "../ApiUrls";
import { toast } from "react-toastify";

function UpdateUserSocialMedialinkModel({ show, onClose, GetHostessProfile, HostessProfile }) {
    const [Facebook, setFacebook] = useState(HostessProfile?.Facebook || "");
    const [Instagram, setInstagram] = useState(HostessProfile?.Instagram || "");
    const [Telegram, setTelegram] = useState(HostessProfile?.Telegram || "");
    const [PersonalWebsite, setPersonalWebsite] = useState(HostessProfile?.PersonalWebsite || "");
    const [LinkedIn, setLinkedIn] = useState(HostessProfile?.LinkedIn || "");
    const [IsUploading, setIsUploading] = useState(false);


    useEffect(() => {
        if (HostessProfile) {
            setFacebook(HostessProfile?.Facebook || "");
            setInstagram(HostessProfile?.Instagram || "");
            setTelegram(HostessProfile?.Telegram || "");
            setPersonalWebsite(HostessProfile?.PersonalWebsite || "");
            setLinkedIn(HostessProfile?.LinkedIn || "");
        }
    }, [HostessProfile]);



    const handleUpdateHostess = async () => {
        if (!Facebook) {
            toast.error("Facebook is required!");
            return;
        }
        if (!Instagram) {
            toast.error("Instagram is required!");
            return;
        }
        if (!Telegram) {
            toast.error("Telegram is required!");
            return;
        }
        if (!PersonalWebsite) {
            toast.error("PersonalWebsite is required!");
            return;
        }
        if (!LinkedIn) {
            toast.error("LinkedIn is required!");
            return;
        }

        try {
            setIsUploading(true);
            let data = { Facebook, Instagram, Telegram, PersonalWebsite, LinkedIn };
            await apiPut("api/user/UpdateUser", data);
            toast.success("Social Media Linkes updated successfully!");
            GetHostessProfile();
            onClose();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to update details.");
        } finally {
            setIsUploading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h2>Update Social Media</h2>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    <div className="about-input" style={{ width: "48%" }}>
                        <label>Facebook</label>
                        <input
                            type="text"
                            placeholder="Enter Facebook Url"
                            value={Facebook}
                            onChange={(e) => setFacebook(e.target.value)}
                        />
                    </div>
                    <div className="about-input" style={{ width: "48%" }}>
                        <label>Instagram</label>
                        <input
                            type="text"
                            placeholder="Enter Instagram Url"
                            value={Instagram}
                            onChange={(e) => setInstagram(e.target.value)}
                        />
                    </div>
                    <div className="about-input" style={{ width: "48%" }}>
                        <label>Telegram</label>
                        <input
                            type="text"
                            placeholder="Enter Telegram Url"
                            value={Telegram}
                            onChange={(e) => setTelegram(e.target.value)}
                        />
                    </div>
                    <div className="about-input" style={{ width: "48%" }}>
                        <label>Personal Website</label>
                        <input
                            type="text"
                            placeholder="Enter Website Url"
                            value={PersonalWebsite}
                            onChange={(e) => setPersonalWebsite(e.target.value)}
                        />
                    </div>
                    <div className="about-input" style={{ width: "48%" }}>
                        <label>LinkedIn</label>
                        <input
                            type="text"
                            placeholder="Enter LinkedIn Url"
                            value={LinkedIn}
                            onChange={(e) => setLinkedIn(e.target.value)}
                        />
                    </div>
                </div>

                <div className="center" style={{ gap: 20 }}>
                    <button onClick={onClose} className="cancel-btn">Cancel</button>
                    <button onClick={handleUpdateHostess} className="save-btn">
                        {IsUploading ? "Updating..." : "Save"}
                    </button>
                </div>
            </div>
        </div>

    );
}

export default UpdateUserSocialMedialinkModel;